/**
 * @fileoverview gRPC-Web generated client stub for activity
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.35.1
// source: score.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var user_pb = require('./user_pb.js')

var activity_pb = require('./activity_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.activity = require('./score_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.activity.ScorerClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.activity.ScorerPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.UserScores,
 *   !proto.activity.UserScores>}
 */
const methodDescriptor_Scorer_GetUserScore = new grpc.web.MethodDescriptor(
  '/activity.Scorer/GetUserScore',
  grpc.web.MethodType.UNARY,
  proto.activity.UserScores,
  proto.activity.UserScores,
  /**
   * @param {!proto.activity.UserScores} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.UserScores.deserializeBinary
);


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.UserScores)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.UserScores>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ScorerClient.prototype.getUserScore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Scorer/GetUserScore',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetUserScore,
      callback);
};


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.UserScores>}
 *     Promise that resolves to the response
 */
proto.activity.ScorerPromiseClient.prototype.getUserScore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Scorer/GetUserScore',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetUserScore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.UserScores,
 *   !proto.activity.UserScores>}
 */
const methodDescriptor_Scorer_getTopUser = new grpc.web.MethodDescriptor(
  '/activity.Scorer/getTopUser',
  grpc.web.MethodType.UNARY,
  proto.activity.UserScores,
  proto.activity.UserScores,
  /**
   * @param {!proto.activity.UserScores} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.UserScores.deserializeBinary
);


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.UserScores)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.UserScores>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ScorerClient.prototype.getTopUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Scorer/getTopUser',
      request,
      metadata || {},
      methodDescriptor_Scorer_getTopUser,
      callback);
};


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.UserScores>}
 *     Promise that resolves to the response
 */
proto.activity.ScorerPromiseClient.prototype.getTopUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Scorer/getTopUser',
      request,
      metadata || {},
      methodDescriptor_Scorer_getTopUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.UserScores,
 *   !proto.activity.UserScoreBodypart>}
 */
const methodDescriptor_Scorer_GetUsersMuscleScores = new grpc.web.MethodDescriptor(
  '/activity.Scorer/GetUsersMuscleScores',
  grpc.web.MethodType.UNARY,
  proto.activity.UserScores,
  proto.activity.UserScoreBodypart,
  /**
   * @param {!proto.activity.UserScores} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.UserScoreBodypart.deserializeBinary
);


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.UserScoreBodypart)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.UserScoreBodypart>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ScorerClient.prototype.getUsersMuscleScores =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Scorer/GetUsersMuscleScores',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetUsersMuscleScores,
      callback);
};


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.UserScoreBodypart>}
 *     Promise that resolves to the response
 */
proto.activity.ScorerPromiseClient.prototype.getUsersMuscleScores =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Scorer/GetUsersMuscleScores',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetUsersMuscleScores);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.UserScores,
 *   !proto.activity.UserScoreBodypart>}
 */
const methodDescriptor_Scorer_GetUsersMusclegroupScores = new grpc.web.MethodDescriptor(
  '/activity.Scorer/GetUsersMusclegroupScores',
  grpc.web.MethodType.UNARY,
  proto.activity.UserScores,
  proto.activity.UserScoreBodypart,
  /**
   * @param {!proto.activity.UserScores} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.UserScoreBodypart.deserializeBinary
);


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.UserScoreBodypart)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.UserScoreBodypart>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ScorerClient.prototype.getUsersMusclegroupScores =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Scorer/GetUsersMusclegroupScores',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetUsersMusclegroupScores,
      callback);
};


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.UserScoreBodypart>}
 *     Promise that resolves to the response
 */
proto.activity.ScorerPromiseClient.prototype.getUsersMusclegroupScores =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Scorer/GetUsersMusclegroupScores',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetUsersMusclegroupScores);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.UserScores,
 *   !proto.activity.UserScores>}
 */
const methodDescriptor_Scorer_GetTopUserByMusclegroup = new grpc.web.MethodDescriptor(
  '/activity.Scorer/GetTopUserByMusclegroup',
  grpc.web.MethodType.UNARY,
  proto.activity.UserScores,
  proto.activity.UserScores,
  /**
   * @param {!proto.activity.UserScores} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.UserScores.deserializeBinary
);


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.UserScores)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.UserScores>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ScorerClient.prototype.getTopUserByMusclegroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Scorer/GetTopUserByMusclegroup',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetTopUserByMusclegroup,
      callback);
};


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.UserScores>}
 *     Promise that resolves to the response
 */
proto.activity.ScorerPromiseClient.prototype.getTopUserByMusclegroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Scorer/GetTopUserByMusclegroup',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetTopUserByMusclegroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.activity.UserScores,
 *   !proto.activity.UserScores>}
 */
const methodDescriptor_Scorer_GetTopUsersByMuscle = new grpc.web.MethodDescriptor(
  '/activity.Scorer/GetTopUsersByMuscle',
  grpc.web.MethodType.UNARY,
  proto.activity.UserScores,
  proto.activity.UserScores,
  /**
   * @param {!proto.activity.UserScores} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.activity.UserScores.deserializeBinary
);


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.activity.UserScores)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.activity.UserScores>|undefined}
 *     The XHR Node Readable Stream
 */
proto.activity.ScorerClient.prototype.getTopUsersByMuscle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/activity.Scorer/GetTopUsersByMuscle',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetTopUsersByMuscle,
      callback);
};


/**
 * @param {!proto.activity.UserScores} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.activity.UserScores>}
 *     Promise that resolves to the response
 */
proto.activity.ScorerPromiseClient.prototype.getTopUsersByMuscle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/activity.Scorer/GetTopUsersByMuscle',
      request,
      metadata || {},
      methodDescriptor_Scorer_GetTopUsersByMuscle);
};


module.exports = proto.activity;

